/*
  Thermasleep page behaviour (sections/thermasleep-native.liquid).

  Everything Replo's runtime used to do on this page, and nothing more. Each
  element is found by the data-rid it already carries in the markup:

    - the product picker: Both Sides / One Side / Full Bed cards, top and bottom,
      switch between three products; the size buttons pick the variant;
    - every price, title, size label, Klarna/Clearpay line, pre-order note and
      button state follows the chosen variant (the generated markup renders all
      of them; this shows the right one, using the same rules Liquid used);
    - add to cart posts /cart/add.js and opens UpCart, as the Replo buttons did;
    - the image galleries rebuild for the chosen product and swipe;
    - accordions, the "Transform" accordion that drives its image carousel,
      the "Need help choosing?" quiz, the sticky bar after 1000px, hover states.

  Videos are started by assets/pdp-video-defer.js (they carry data-defer).
*/
(function () {
  'use strict';
  const page = document.getElementById('tsn-page');
  const dataEl = document.getElementById('tsn-products');
  const statesEl = document.getElementById('tsn-states');
  if (!page || !dataEl || !statesEl || page.dataset.tsnBound) return;
  page.dataset.tsnBound = '1';

  const data = JSON.parse(dataEl.textContent);
  const states = JSON.parse(statesEl.textContent);
  const products = {};
  data.products.forEach((p) => { products[p.id] = p; });

  const FULL_BED = data.ids.full;
  const I = data.i18n || {};
  const all = (rid) => Array.from(page.querySelectorAll(`[data-rid^="${rid}"]`));
  const canHover = window.matchMedia('(hover: hover)').matches;

  let product = products[data.initial];
  let variant = product.variants.find((v) => v.id === product.selected) || product.variants[0];

  /* ---------- money ---------- */
  function money(cents) {
    const sample = data.moneySample || '';
    const num = sample.match(/1([^\d]?)234([^\d])56/);
    if (num) {
      const [i, f] = (cents / 100).toFixed(2).split('.');
      return sample.replace(num[0], i.replace(/\B(?=(\d{3})+(?!\d))/g, num[1]) + num[2] + f);
    }
    const fmt = '€{{amount}}';
    const fixed = (n, d) => (n / 100).toFixed(d);
    const withCommas = (s, sep, dec) => {
      const [i, f] = s.split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (f ? dec + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      if (key === 'amount_no_decimals') return withCommas(fixed(cents, 0), ',', '.');
      if (key === 'amount_with_comma_separator') return withCommas(fixed(cents, 2), '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return withCommas(fixed(cents, 0), '.', ',');
      return withCommas(fixed(cents, 2), ',', '.');
    });
  }

  /* ---------- state branches (Replo's "first true variant") ---------- */
  function test(node) {
    switch (node[0]) {
      case 'variant': return variant.id === node[1];
      case 'product': return product.id === node[1];
      case 'soldout': return !variant.available;
      case 'and': return test(node[1]) && test(node[2]);
      case 'or': return test(node[1]) || test(node[2]);
      default: return false;
    }
  }

  function applyStates() {
    Object.keys(states).forEach((group) => {
      const hit = states[group].find(([, cond]) => test(cond));
      const key = hit ? hit[0] : '';
      page.querySelectorAll(`[data-tsn-g="${group}"]`).forEach((el) => {
        el.classList.toggle('tsn-off', el.dataset.tsnK !== key);
      });
    });
  }

  /* ---------- simple bound values ---------- */
  function applyBinds() {
    page.querySelectorAll('[data-tsn-bind="price"]').forEach((el) => { el.textContent = money(variant.price); });
    page.querySelectorAll('[data-tsn-bind="title"]').forEach((el) => { el.textContent = product.title; });
    page.querySelectorAll('[data-tsn-bind="option1"]').forEach((el) => { el.textContent = variant.option1; });
    page.querySelectorAll('[data-tsn-bind="featured"]').forEach((pic) => {
      pic.querySelectorAll('source').forEach((s) => {
        const w = (s.getAttribute('srcset') || '').match(/width=(\d+)/);
        s.setAttribute('srcset', product.featured + (w ? `&width=${w[1]}` : ''));
      });
      const img = pic.querySelector('img');
      if (img) img.src = product.featured;
    });
    page.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach((i) => { i.value = variant.id; });
    // Klarna amount as on the other product pages: a third of the price, to the nearest pound.
    page.querySelectorAll('[data-tsn-bind="klarna"]').forEach((el) => { el.textContent = money(Math.round(variant.price / 300) * 100).replace(/\.00$/, ''); });
    renderBuybox();
  }

  /* ---------- the buy box at the top (snippets/thermasleep-native-buybox.liquid) ---------- */
  const buybox = page.querySelector('[data-tsn-buybox]');
  let shownRender = null;
  function renderBuybox() {
    if (!buybox) return;
    buybox.querySelectorAll('[data-tsn-pick]').forEach((card) => {
      const on = Number(card.dataset.tsnPick) === product.id;
      card.classList.toggle('is-on', on);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    const sizes = buybox.querySelector('[data-tsn-sizes]');
    if (sizes) {
      const values = [];
      product.variants.forEach((v) => { if (!values.includes(v.option1)) values.push(v.option1); });
      sizes.innerHTML = '';
      values.forEach((value) => {
        const b = document.createElement('button');
        const on = value === variant.option1;
        b.type = 'button';
        b.className = 'tsb__size' + (on ? ' is-on' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.dataset.tsnSize = value;
        b.textContent = value;
        sizes.appendChild(b);
      });
    }
    const note = buybox.querySelector('[data-tsn-fullbed-note]');
    if (note) note.hidden = product.id !== FULL_BED;
    const img = buybox.querySelector('[data-tsn-render]');
    if (img && product.render && shownRender !== product.render) {
      if (shownRender !== null) {
        img.srcset = [800, 1400, 2000].map((w) => `${product.render}&width=${w} ${w}w`).join(', ');
        img.src = `${product.render}&width=1400`;
      }
      shownRender = product.render;
    }
  }

  if (buybox) {
    buybox.addEventListener('click', (e) => {
      const card = e.target.closest('[data-tsn-pick]');
      if (card) {
        const p = products[Number(card.dataset.tsnPick)];
        if (!p) return;
        const v = p.variants.find((x) => x.id === Number(card.dataset.tsnPickVariant)) || p.variants[0];
        all(FULL_BED_NOTE.rid).forEach((n) => n.classList.toggle(FULL_BED_NOTE.on, p.id === FULL_BED));
        select(p, v);
        return;
      }
      const size = e.target.closest('[data-tsn-size]');
      if (size) {
        const v = product.variants.find((x) => x.option1 === size.dataset.tsnSize);
        if (v) select(product, v);
      }
    });
    // Phone gallery: the dots follow the swipe.
    const slides = buybox.querySelector('[data-tsn-slides]');
    const dots = buybox.querySelectorAll('[data-tsn-dots] span');
    if (slides && dots.length) {
      slides.addEventListener('scroll', () => {
        const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
      }, { passive: true });
    }
  }

  /* ---------- size buttons ---------- */
  const optionLists = ['cc7d1e46', '5885a13d'].flatMap(all).map((list) => {
    const items = Array.from(list.querySelectorAll('[role="option"]'));
    const on = items.find((i) => i.getAttribute('aria-selected') === 'true');
    const off = items.find((i) => i.getAttribute('aria-selected') === 'false');
    return { list, on: on && on.cloneNode(true), off: off && off.cloneNode(true) };
  }).filter((o) => o.on && o.off);

  function renderOptions() {
    const values = [];
    product.variants.forEach((v) => { if (!values.includes(v.option1)) values.push(v.option1); });
    optionLists.forEach(({ list, on, off }) => {
      list.querySelectorAll('[role="option"]').forEach((i) => i.remove());
      values.forEach((value) => {
        const item = (value === variant.option1 ? on : off).cloneNode(true);
        const text = item.querySelector('p') || item;
        text.textContent = value;
        item.dataset.tsnValue = value;
        list.appendChild(item);
      });
    });
  }

  page.addEventListener('click', (e) => {
    const item = e.target.closest('[role="option"][data-tsn-value]');
    if (!item) return;
    const v = product.variants.find((x) => x.option1 === item.dataset.tsnValue);
    if (v) select(product, v);
  });

  /* ---------- carousels ---------- */
  const carousels = [];

  function makeCarousel(root, opts) {
    const track = root.querySelector('[data-tsn-part="slide-track"]');
    if (!track) return null;
    const dotItem = opts.dots ? all(opts.dots).find((d) => root.contains(d)) : null;
    const dots = dotItem ? dotItem.parentElement : null;
    const c = { root, track, dots, opts, index: 0, count: 0 };
    const dotTpl = dots && dots.firstElementChild ? dots.firstElementChild.cloneNode(true) : null;
    if (dotTpl) dotTpl.classList.remove(opts.dotOn);
    const slideTpl = track.querySelector('[data-tsn-part="slide"]');
    c.template = slideTpl ? slideTpl.outerHTML : '';

    c.build = (urls) => {
      if (opts.images) {
        const from = opts.templateUrl;
        const real = urls.map((u) => c.template.split(from).join(u));
        track.innerHTML = real.join('');
      }
      const reals = Array.from(track.querySelectorAll('[data-tsn-part="slide"]'));
      reals.forEach((s, i) => {
        s.removeAttribute('data-is-active');
        s.removeAttribute('data-is-cloned');
        s.removeAttribute('data-is-target');
        s.setAttribute('aria-label', `Slide ${i + 1}`);
        s.removeAttribute('id');
      });
      c.count = reals.length;
      if (opts.infinite) {
        const first = reals[0].cloneNode(true);
        const last = reals[reals.length - 1].cloneNode(true);
        [first, last].forEach((n) => { n.dataset.tsnClone = '1'; n.setAttribute('aria-hidden', 'true'); });
        track.insertBefore(last, reals[0]);
        track.appendChild(first);
      }
      if (dots && dotTpl) {
        dots.innerHTML = '';
        for (let i = 0; i < c.count; i++) {
          const d = dotTpl.cloneNode(true);
          d.setAttribute('aria-label', `Go to slide ${i + 1}`);
          d.addEventListener('click', () => c.go(i));
          dots.appendChild(d);
        }
      }
      const sr = root.querySelector('.tsn-sr-only');
      if (sr) sr.textContent = I.slide.replace('[n]', 1).replace('[count]', c.count);
      c.index = 0;
      c.place(false);
    };

    c.step = () => {
      const slides = track.querySelectorAll('[data-tsn-part="slide"]');
      if (slides.length < 2) return slides[0] ? slides[0].getBoundingClientRect().width : 0;
      return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
    };

    c.place = (animate, drag = 0) => {
      const offset = (opts.infinite ? c.index + 1 : c.index) * c.step();
      track.style.transitionProperty = animate ? 'transform' : 'none';
      track.style.transitionDuration = animate ? '400ms' : '0ms';
      track.style.transitionTimingFunction = 'ease';
      track.style.transform = `translate3d(${-offset + drag}px, 0px, 0px)`;
      const shown = ((c.index % c.count) + c.count) % c.count;
      if (dots) Array.from(dots.children).forEach((d, i) => {
        d.classList.toggle(opts.dotOn, i === shown);
        d.setAttribute('aria-current', i === shown ? 'true' : 'false');
      });
      const sr = root.querySelector('.tsn-sr-only');
      if (sr) sr.textContent = I.slide.replace('[n]', shown + 1).replace('[count]', c.count);
    };

    c.go = (i) => {
      if (c.count < 2) return;
      if (opts.infinite) {
        c.index = i;
        c.place(true);
        if (i < 0 || i >= c.count) {
          setTimeout(() => { c.index = (i + c.count) % c.count; c.place(false); }, 410);
        }
      } else {
        c.index = Math.max(0, Math.min(c.count - 1, i));
        c.place(true);
      }
      if (opts.onChange) opts.onChange(((c.index % c.count) + c.count) % c.count);
    };

    root.querySelectorAll('[data-tsn-part="nav-button"]').forEach((b) => {
      b.addEventListener('click', () => c.go(c.index + (b.dataset.direction === 'next' ? 1 : -1)));
    });

    // Swipe and drag, as Replo's carousel allowed. Vertical scrolling is left alone.
    // Touch and mouse are handled separately: pointer events get cancelled by the
    // browser's own image drag, which is why a single pointer handler did nothing.
    let startX = null, startY = 0, dx = 0, dragging = false;
    const viewport = root.querySelector('[data-tsn-part="slides"]') || track;
    const begin = (x, y) => { if (c.count < 2) return; startX = x; startY = y; dx = 0; dragging = false; };
    const move = (x, y) => {
      if (startX === null) return false;
      dx = x - startX;
      if (!dragging && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(y - startY)) dragging = true;
      if (dragging) c.place(false, dx);
      return dragging;
    };
    const end = () => {
      if (startX === null) return;
      startX = null;
      if (!dragging) return;
      const threshold = Math.min(60, c.step() / 5);
      if (dx < -threshold) c.go(c.index + 1);
      else if (dx > threshold) c.go(c.index - 1);
      else c.place(true);
      dragging = false;
    };
    viewport.addEventListener('touchstart', (e) => begin(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
    viewport.addEventListener('touchmove', (e) => { if (move(e.touches[0].clientX, e.touches[0].clientY) && e.cancelable) e.preventDefault(); }, { passive: false });
    viewport.addEventListener('touchend', end);
    viewport.addEventListener('touchcancel', end);
    viewport.addEventListener('mousedown', (e) => { if (e.button === 0) begin(e.clientX, e.clientY); });
    window.addEventListener('mousemove', (e) => move(e.clientX, e.clientY));
    window.addEventListener('mouseup', end);
    viewport.addEventListener('dragstart', (e) => e.preventDefault());
    viewport.addEventListener('click', (e) => { if (Math.abs(dx) > 8) { e.preventDefault(); e.stopPropagation(); dx = 0; } }, true);
    viewport.style.touchAction = 'pan-y';

    window.addEventListener('resize', () => c.place(false));
    carousels.push(c);
    return c;
  }

  // The two product galleries (phone and computer layouts) follow product.images.
  const initialImages = products[data.initial].images;
  const galleries = [
    ['d1fbb592', 'a4e3337c', 'r-1qihnuz'],
    ['6030f06e', '1ce82884', 'r-lv4k3j'],
  ].map(([rid, dots, dotOn]) => all(rid).map((root) => makeCarousel(root, {
    images: true, infinite: true, dots, dotOn, templateUrl: initialImages[0],
  }))).flat().filter(Boolean);
  galleries.forEach((g) => g.build(initialImages));

  /* ---------- accordions ---------- */
  const PLUS = 'M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4';
  const MINUS = 'M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8';
  const accordions = [
    { root: 'a004da77', header: '216bb044', icon: 'f55b9df6', iconOn: 'r-1vx02z3', group: 'buy', svg: true },
    { root: 'd81f91d4', header: '8ecb81e2', icon: 'd4ba6c05', iconOn: 'r-11awfwn', group: 'buy', svg: true },
    { root: '2ec42cd0', header: '0b8d2d4d', icon: 'b218ec4b', iconOn: 'r-6rvnqe', group: 'buy', svg: true },
    { root: '9b04f0e3', header: 'a75206fd', icon: '80f7e5d9', iconOn: 'r-tvx9t3', group: 'buy', svg: true },
    { root: 'cb8e7695', header: 'ecea4247', headerOn: 'r-1l5jrn5', group: 'transform', slide: 0, animate: true },
    { root: '90099024', header: '9cf877d4', headerOn: 'r-1cpjg5u', group: 'transform', slide: 1, animate: true },
  ];

  // The "Transform Your Existing Mattress" accordion turns its image carousel.
  const transform = all('1ecf0802').map((root) => makeCarousel(root, { dots: 'afe07981', dotOn: 'r-1dv02gm' })).filter(Boolean);
  transform.forEach((c) => c.build());

  function setOpen(a, open) {
    all(a.root).forEach((root) => {
      const header = root.querySelector(`[data-rid^="${a.header}"]`);
      const body = header && header.nextElementSibling;
      root.dataset.state = open ? 'open' : 'closed';
      if (header) {
        header.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (a.headerOn) header.classList.toggle(a.headerOn, open);
      }
      if (a.icon) {
        root.querySelectorAll(`[data-rid^="${a.icon}"]`).forEach((icon) => {
          icon.classList.toggle(a.iconOn, open);
          const path = icon.querySelector('svg path');
          if (a.svg && path) path.setAttribute('d', open ? MINUS : PLUS);
        });
      }
      if (!body) return;
      if (!a.animate) { body.hidden = !open; return; }
      if (open) {
        body.hidden = false;
        const h = body.scrollHeight;
        body.style.overflow = 'hidden';
        body.style.height = '0px';
        body.offsetHeight; // eslint-disable-line no-unused-expressions
        body.style.transition = 'height 300ms ease';
        body.style.height = h + 'px';
        setTimeout(() => { body.style.height = ''; body.style.overflow = ''; body.style.transition = ''; }, 320);
      } else if (!body.hidden) {
        body.style.overflow = 'hidden';
        body.style.height = body.scrollHeight + 'px';
        body.offsetHeight; // eslint-disable-line no-unused-expressions
        body.style.transition = 'height 300ms ease';
        body.style.height = '0px';
        setTimeout(() => { body.hidden = true; body.style.height = ''; body.style.overflow = ''; body.style.transition = ''; }, 320);
      }
    });
  }

  accordions.forEach((a) => {
    all(a.header).forEach((header) => {
      const toggle = () => {
        const root = header.closest('[data-tsn-collapsible]');
        const opening = !(root && root.dataset.state === 'open');
        if (opening) accordions.filter((o) => o.group === a.group && o !== a).forEach((o) => setOpen(o, false));
        setOpen(a, opening);
        if (opening && a.slide !== undefined) transform.forEach((c) => c.go(a.slide));
      };
      header.addEventListener('click', toggle);
      header.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  });

  /* ---------- choosing a product or size ---------- */
  function select(p, v) {
    const productChanged = p !== product;
    product = p;
    variant = v;
    applyStates();
    applyBinds();
    renderOptions();
    if (productChanged) galleries.forEach((g) => g.build(product.images));
    applyDispatch();
  }

  const FULL_BED_NOTE = { rid: '10d1626d', on: 'r-199n919' };
  const cards = [
    // top buy box: also sets the "Full Bed is not available in Super King" note, as Replo did
    { rid: '37e0743d', product: data.ids.both, variant: null, note: false },
    { rid: 'b8d81cd1', product: data.ids.one, variant: null, note: false },
    { rid: '194119fc', product: FULL_BED, variant: null, note: true },
    // bottom ("What's Included") buy box
    { rid: '49e66f74', product: data.ids.both, variant: null },
    { rid: 'af6ca4c2', product: data.ids.one, variant: null },
    { rid: '2521a3eb', product: FULL_BED, variant: null },
  ];
  cards.forEach((card) => {
    all(card.rid).forEach((el) => {
      el.style.cursor = 'pointer';
      el.addEventListener('click', () => {
        const p = products[card.product];
        if (!p) return;
        const v = p.variants.find((x) => x.id === card.variant) || p.variants.find((x) => x.id === p.selected) || p.variants[0];
        if (card.note !== undefined) all(FULL_BED_NOTE.rid).forEach((n) => n.classList.toggle(FULL_BED_NOTE.on, card.note));
        select(p, v);
      });
    });
  });

  /* ---------- add to cart ---------- */
  async function addToCart(button) {
    if (!variant.available || button.dataset.tsnBusy) return false;
    button.dataset.tsnBusy = '1';
    try {
      const res = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [Object.assign({ id: String(variant.id), quantity: 1, properties: variant.plan ? { _is_preorder: 'Item on pre-order' } : {} },
          variant.plan ? { selling_plan: String(variant.plan) } : {})] }),
      });
      if (!res.ok) throw new Error(await res.text());
      for (let i = 0; i < 40 && typeof window.upcartOpenCart !== 'function'; i++) await new Promise((r) => setTimeout(r, 50));
      if (typeof window.upcartRefreshCart === 'function') { try { await window.upcartRefreshCart(); } catch (e) { /* no-op */ } }
      if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
      else document.dispatchEvent(new CustomEvent('upcart:refresh'));
      return true;
    } catch (err) {
      console.error('Thermasleep: add to cart failed', err);
      return false;
    } finally {
      delete button.dataset.tsnBusy;
    }
  }

  page.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-tsn-add-product-variant-to-cart]');
    if (!button) return;
    e.preventDefault();
    const added = await addToCart(button);
    // The sticky bar's "+" turns into a tick once something is in the basket.
    if (added && button.matches('[data-rid^="8dfa4ddf"]')) {
      button.querySelectorAll('source').forEach((s) => s.setAttribute('srcset', data.tick));
      const img = button.querySelector('img');
      if (img) img.src = data.tick;
    }
  });
  page.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-tsn-add-product-variant-to-cart][role="button"]:not(button)')) {
      e.preventDefault();
      e.target.click();
    }
  });

  /* ---------- hero buttons ---------- */
  const hero = document.querySelector('[data-tsn-hero]');
  const scrollToEl = (el) => {
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top, behavior: 'smooth' });
  };
  if (hero) {
    hero.querySelector('[data-tsn-hero-shop]')?.addEventListener('click', (e) => {
      e.preventDefault();
      scrollToEl(page.querySelector('[data-tsn-buybox]'));
    });
    hero.querySelector('[data-tsn-hero-how]')?.addEventListener('click', (e) => {
      e.preventDefault();
      // The "Powered by water" section, found by its words since its markup is Replo's.
      const heading = [...page.querySelectorAll('h1,h2,h3,p,span,div')].find((el) =>
        el.children.length === 0 && el.textContent.trim().toLowerCase() === (I.powered_by_water || 'powered by water').toLowerCase() && el.offsetParent);
      scrollToEl(heading || page.querySelector('[data-tsn-buybox]'));
    });
  }

  /* ---------- "Need help choosing?" quiz ---------- */
  const quiz = document.querySelector('[data-tsn-quiz]');
  const ONE_SIDE = data.ids.one;
  const BOTH_SIDES = data.ids.both;
  const MATCHES = {
    [BOTH_SIDES]: {
      name: I.both, pods: I.pods_2,
      why: I.why_both,
      ticks: [I.tick_both_1, I.tick_both_2, I.tick_both_3],
    },
    [ONE_SIDE]: {
      name: I.one, pods: I.pods_1,
      why: I.why_one,
      ticks: [I.tick_one_1, I.tick_one_2, I.tick_one_3],
    },
    [FULL_BED]: {
      name: I.full, pods: I.pods_1,
      why: I.why_full,
      ticks: [I.tick_full_1, I.tick_full_2, I.tick_full_3],
    },
  };
  const ANSWERS = {
    solo: 'solo-2', share: 'share-2',
    whole: FULL_BED, side: ONE_SIDE,
    same: FULL_BED, different: BOTH_SIDES, 'only-me': ONE_SIDE,
  };
  const TICK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0FA0EA" stroke-width="2" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
  const sized = (url, w) => url + (url.includes('?') ? '&' : '?') + 'width=' + w;
  let quizHistory = ['1'];
  let quizProduct = null;
  let quizVariant = null;
  let quizOpener = null;

  function quizShow(step) {
    quiz.querySelectorAll('.tsq__step').forEach((s) => s.classList.toggle('is-on', s.dataset.step === step));
    const isResult = step === 'result';
    quiz.classList.toggle('is-result', isResult);
    quiz.querySelector('[data-tsn-quiz-back]').hidden = quizHistory.length < 2;
    quiz.querySelector('[data-tsn-quiz-count]').textContent = isResult ? I.your_match : I.question.replace('[n]', quizHistory.length);
    quiz.querySelector('[data-tsn-quiz-progress]').style.width = isResult ? '100%' : `${quizHistory.length * 50 - 25}%`;
    quiz.querySelector('.tsq__panel').scrollTop = 0;
  }

  function quizRender() {
    const m = MATCHES[quizProduct.id];
    quiz.querySelector('[data-tsn-quiz-name]').textContent = m.name;
    quiz.querySelector('[data-tsn-quiz-pods]').textContent = m.pods;
    quiz.querySelector('[data-tsn-quiz-why]').textContent = m.why;
    quiz.querySelector('[data-tsn-quiz-ticks]').innerHTML = m.ticks.map((t) => `<li>${TICK}<span>${t}</span></li>`).join('');
    const img = quiz.querySelector('[data-tsn-quiz-img]');
    img.src = sized(quizProduct.render, 900);
    img.alt = `Thermasleep ${m.name}`;
    quiz.querySelector('[data-tsn-quiz-note]').hidden = quizProduct.id !== FULL_BED;
    quiz.querySelector('[data-tsn-quiz-sizes]').innerHTML = quizProduct.variants.map((v) =>
      `<button type="button" class="tsq__size${v.id === quizVariant.id ? ' is-on' : ''}" data-variant="${v.id}" aria-pressed="${v.id === quizVariant.id}"${v.available ? '' : ' disabled'}>${v.option1}</button>`).join('');
    const buy = quiz.querySelector('[data-tsn-quiz-buy]');
    buy.disabled = !quizVariant.available;
    buy.firstElementChild.innerHTML = quizVariant.available
      ? `${I.pre_order} | <span>${money(quizVariant.price)}</span>`
      : I.sold_out;
    quiz.querySelector('[data-tsn-quiz-others]').innerHTML = [BOTH_SIDES, ONE_SIDE, FULL_BED]
      .filter((id) => id !== quizProduct.id && products[id])
      .map((id) => {
        const o = MATCHES[id];
        const p = products[id];
        return `<button type="button" class="tsq__other" data-product="${id}"><img src="${sized(p.render, 200)}" alt="" loading="lazy"><span><b>${o.name} · ${o.pods}</b>${o.why}</span><em>${money(p.variants[0].price)}</em></button>`;
      }).join('');
  }

  function quizMatch(id) {
    const p = products[id];
    if (!p) return;
    // Keep the bed size already picked (in the quiz or the buy box) where this product has it.
    const size = quizVariant ? quizVariant.option1 : variant.option1;
    quizProduct = p;
    quizVariant = p.variants.find((v) => v.option1 === size && v.available) || p.variants.find((v) => v.available) || p.variants[0];
    quizRender();
  }

  let quizPreloaded = false;
  function openQuiz(e) {
    if (!quiz) return;
    // Fetch the three bed renders now so the match never shows an empty picture.
    if (!quizPreloaded) {
      quizPreloaded = true;
      data.products.forEach((p) => { new Image().src = sized(p.render, 900); new Image().src = sized(p.render, 200); });
    }
    quizOpener = e && e.currentTarget instanceof HTMLElement ? e.currentTarget : document.activeElement;
    quizHistory = ['1'];
    quizVariant = null;
    quiz.querySelectorAll('.tsq__opt').forEach((o) => o.classList.remove('is-on'));
    quizShow('1');
    quiz.hidden = false;
    document.documentElement.classList.add('tsq-locked');
    requestAnimationFrame(() => {
      quiz.classList.add('is-open');
      quiz.querySelector('.tsq__panel').focus({ preventScroll: true });
    });
  }

  function closeQuiz() {
    if (!quiz || quiz.hidden) return;
    quiz.classList.remove('is-open');
    document.documentElement.classList.remove('tsq-locked');
    setTimeout(() => { quiz.hidden = true; }, 250);
    if (quizOpener && document.contains(quizOpener)) quizOpener.focus({ preventScroll: true });
  }

  if (quiz) {
    document.body.appendChild(quiz);
    quiz.addEventListener('click', async (e) => {
      const t = e.target;
      if (t.closest('[data-tsn-quiz-close]')) return closeQuiz();
      const opt = t.closest('.tsq__opt');
      if (opt) {
        opt.parentElement.querySelectorAll('.tsq__opt').forEach((o) => o.classList.toggle('is-on', o === opt));
        const next = ANSWERS[opt.dataset.answer];
        // A short pause so the tap shows before the next question slides in.
        setTimeout(() => {
          if (typeof next === 'string') {
            quizHistory.push(next);
            quizShow(next);
          } else {
            quizHistory.push('result');
            quizVariant = null;
            quizMatch(next);
            quizShow('result');
          }
        }, 180);
        return;
      }
      if (t.closest('[data-tsn-quiz-back]')) {
        quizHistory.pop();
        quizShow(quizHistory[quizHistory.length - 1]);
        return;
      }
      if (t.closest('[data-tsn-quiz-restart]')) {
        quizHistory = ['1'];
        quiz.querySelectorAll('.tsq__opt').forEach((o) => o.classList.remove('is-on'));
        quizShow('1');
        return;
      }
      const size = t.closest('.tsq__size');
      if (size && !size.disabled) {
        quizVariant = quizProduct.variants.find((v) => String(v.id) === size.dataset.variant) || quizVariant;
        quizRender();
        return;
      }
      const other = t.closest('.tsq__other');
      if (other) {
        quizMatch(Number(other.dataset.product));
        quiz.querySelector('.tsq__panel').scrollTop = 0;
        return;
      }
      if (t.closest('[data-tsn-quiz-show]')) {
        select(quizProduct, quizVariant);
        closeQuiz();
        scrollToEl(page.querySelector('[data-tsn-buybox]'));
        return;
      }
      const buy = t.closest('[data-tsn-quiz-buy]');
      if (buy && !buy.disabled) {
        select(quizProduct, quizVariant);
        if (await addToCart(buy)) closeQuiz();
      }
    });
    quiz.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      // Keep keyboard focus inside the quiz while it is open.
      const focusable = Array.from(quiz.querySelectorAll('.tsq__step.is-on button:not(:disabled), .tsq__bar button:not([hidden])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // "need help choosing?", and both "Help me decide" links (the top one did nothing on the Replo page).
  ['f5eccabf', '0b561ec7', 'bafda05b'].forEach((rid) => all(rid).forEach((el) => {
    el.style.cursor = 'pointer';
    el.addEventListener('click', openQuiz);
  }));
  page.querySelectorAll('[data-tsn-quiz-open]').forEach((el) => el.addEventListener('click', openQuiz));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeQuiz(); });

  /* ---------- sticky bar, "Update" link ---------- */
  const STICKY = { rid: 'a935264c', on: 'r-6dovso' };
  const sticky = all(STICKY.rid);
  let ticking = false;
  const onScroll = () => {
    ticking = false;
    const show = window.scrollY > 1000;
    sticky.forEach((el) => el.classList.toggle(STICKY.on, show));
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  all('d34c7158').forEach((el) => el.addEventListener('click', () => {
    const target = document.getElementById('Product');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  /* ---------- hover states ---------- */
  const SELECTED = ['r-1y3fiqp', 'r-1kwhcwo', 'r-1m9gnw9', 'r-1o3krz7', 'r-12yr4wf', 'r-i5jdmq'];
  if (canHover) {
    [
      ['37e0743d', 'r-1irgrsq'], ['194119fc', 'r-rhfixb'], ['49e66f74', 'r-saeq2e'],
      ['2521a3eb', 'r-ku3u6c'], ['ee0540a4', 'r-1c0rfdv'], ['8dfa4ddf', 'r-u0az5l'],
    ].forEach(([rid, cls]) => all(rid).forEach((el) => {
      // A selected card keeps its selected look under the pointer, as on the Replo page.
      el.addEventListener('mouseenter', () => { if (!SELECTED.some((c) => el.classList.contains(c))) el.classList.add(cls); });
      el.addEventListener('click', () => el.classList.remove(cls));
      el.addEventListener('mouseleave', () => el.classList.remove(cls));
    }));
  }

  function dispatchDate() {
    const raw = (typeof window.PulsioGloboDispatch === 'function' && variant.plan && window.PulsioGloboDispatch(String(variant.plan))) || '';
    const m = String(raw).match(/^From (\d{1,2}) ([A-Za-z]{3}) (\d{4})$/);
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const d = m ? new Date(Date.UTC(+m[3], months.indexOf(m[2]), +m[1])) : new Date(data.dispatch + 'T00:00:00Z');
    if (typeof window.PulsioPreorderDate === 'function') return window.PulsioPreorderDate(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    try { return new Intl.DateTimeFormat(data.locale === 'en' ? 'en-GB' : data.locale || 'en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d); }
    catch (e) { return data.dispatch; }
  }
  function applyDispatch() {
    page.querySelectorAll('[data-tsn-dispatch]').forEach((el) => {
      el.innerHTML = `<b>${(window.PulsioPreorderI18n || {}).pill || I.pre_order}</b> · ${I.expected_dispatch.replace('[date]', dispatchDate())}`;
    });
  }
  select(product, variant);
})();
